import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,[_c(VRow,[_c(VCol,[_c(VTextField,{attrs:{"disabled":_vm.disabled,"readonly":_vm.readonly,"type":"number","min":"0","label":_vm.$t('pages.program.catalog.createModal.cashbackValue'),"value":_vm.form.cashback.value},on:{"change":_vm.changeCashbackValue}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }